// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Site diary / Bautagebuch (/user/site-diary, project tab) */

.site-diary-page .sdi-full {
  width: 100%;
}

.site-diary-page .sdi-small {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.site-diary-page .sdi-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.site-diary-page .sdi-pre,
.site-diary-page .sdi-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.site-diary-page .sdi-hash {
  font-family: "Courier New", monospace;
  font-size: 11px;
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

.site-diary-page .sdi-card {
  margin-bottom: var(--ds-space-3, 12px);
}

.site-diary-page .sdi-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--ds-text-muted);
  margin-block: var(--ds-space-2, 8px) 4px;
}

.site-diary-page .sdi-day-tag {
  cursor: pointer;
  margin-block: 2px;
}

/* ---- Overview ---- */
.site-diary-page .sdi-project-select {
  width: 100%;
  min-width: 0;
  max-width: 420px;
}

.site-diary-page .sdi-missing {
  margin-bottom: var(--ds-space-3, 12px);
}

.site-diary-page .sdi-empty {
  margin-block: var(--ds-space-6, 32px);
}

.site-diary-page .sdi-project-actions {
  margin-bottom: var(--ds-space-3, 12px);
}

.site-diary-page .sdi-missing-line {
  margin-bottom: var(--ds-space-2, 8px);
}

.site-diary-page .sdi-entry-item {
  cursor: pointer;
  padding-inline: var(--ds-space-2, 8px);
  border-radius: var(--ds-radius-sm, 6px);
}

.site-diary-page .sdi-entry-item:hover {
  background: var(--ds-surface-muted);
}

/* ---- Calendar ---- */
.site-diary-page .sdi-calendar {
  border: 1px solid var(--ds-border, rgba(0, 0, 0, 0.08));
  border-radius: var(--ds-radius-md, 10px);
  padding: var(--ds-space-2, 8px);
}

.site-diary-page .sdi-cal-cell {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.site-diary-page .sdi-cal-dot,
.site-diary-page .sdi-legend-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--ds-text-muted);
}

.site-diary-page .sdi-cal-cell--filled .sdi-cal-dot,
.site-diary-page .sdi-legend-dot--filled {
  background: var(--ds-brand, #157f9f);
}

.site-diary-page .sdi-cal-cell--locked .sdi-cal-dot,
.site-diary-page .sdi-legend-dot--locked {
  background: var(--ds-success);
}

.site-diary-page .sdi-cal-cell--missing .sdi-cal-dot,
.site-diary-page .sdi-legend-dot--missing {
  background: var(--ds-danger);
}

.site-diary-page .sdi-legend {
  margin-top: var(--ds-space-2, 8px);
  font-size: 12px;
}

/* ---- Day editor ---- */
.sdi-editor {
  max-width: 880px;
  margin-inline: auto;
  padding-bottom: 88px;
}

.sdi-editor .sdi-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2, 8px);
  margin-bottom: var(--ds-space-2, 8px);
}

.sdi-editor .sdi-header-title {
  flex: 1;
  min-width: 0;
}

.sdi-editor .sdi-header-title h4 {
  margin: 0;
  overflow-wrap: anywhere;
}

.sdi-editor .sdi-daynav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2, 8px);
  margin-bottom: var(--ds-space-3, 12px);
}

.sdi-editor .sdi-daynav-date {
  text-align: center;
  flex: 1;
}

.sdi-editor .sdi-lock {
  margin-bottom: var(--ds-space-3, 12px);
}

.sdi-editor .sdi-row {
  padding-block: var(--ds-space-2, 8px);
  border-bottom: 1px solid var(--ds-border, rgba(0, 0, 0, 0.06));
}

.sdi-editor .sdi-row-actions {
  text-align: end;
}

.sdi-editor .sdi-source {
  margin-inline-start: var(--ds-space-2, 8px);
}

.sdi-editor .sdi-add {
  margin-top: var(--ds-space-2, 8px);
}

.sdi-editor .sdi-section + .sdi-section {
  margin-top: var(--ds-space-2, 8px);
}

.sdi-editor .sdi-card--others {
  background: var(--ds-surface-muted);
}

.sdi-editor .sdi-dictation .sdi-mic {
  margin-top: var(--ds-space-2, 8px);
  min-height: 40px;
}

.sdi-editor .sdi-mic--active {
  animation: sdi-pulse 1.4s ease-in-out infinite;
}

.sdi-editor .sdi-interim {
  margin: var(--ds-space-2, 8px) 0 0;
  font-style: italic;
}

.sdi-editor .sdi-rec-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ds-danger);
}

@keyframes sdi-pulse {
  50% {
    opacity: 0.7;
  }
}

.sdi-editor .sdi-obstruction {
  border: 1px solid var(--ds-warning);
  border-radius: var(--ds-radius-sm, 6px);
  padding: var(--ds-space-2, 8px) var(--ds-space-3, 12px);
  margin-bottom: var(--ds-space-2, 8px);
}

.sdi-editor .sdi-obstruction-foot,
.sdi-editor .sdi-notice-actions {
  margin-top: var(--ds-space-2, 8px);
}

.site-diary-page .sdi-photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: var(--ds-space-2, 8px);
}

.site-diary-page .sdi-photo-grid figure {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.site-diary-page .sdi-photo-grid img,
.site-diary-page .sdi-photo-grid .ant-image,
.site-diary-page .sdi-photo-grid .ant-image-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: var(--ds-radius-sm, 6px);
}

.sdi-editor .sdi-photo-actions {
  margin-block: var(--ds-space-2, 8px);
}

.sdi-editor .sdi-signatures {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--ds-space-3, 12px);
  margin-bottom: var(--ds-space-3, 12px);
}

.sdi-editor .sdi-signature img {
  max-height: 72px;
  max-width: 100%;
  display: block;
}

.sdi-editor .sdi-savebar {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-space-2, 8px);
  padding: var(--ds-space-3, 12px);
  margin-inline: calc(-1 * var(--ds-space-3, 12px));
  background: var(--ds-surface, #fff);
  border-top: 1px solid var(--ds-border, rgba(0, 0, 0, 0.08));
  z-index: 5;
}

@media (max-width: 767px) {
  .sdi-editor .sdi-savebar .ant-btn-primary {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/siteDiary/siteDiary.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,uDAAuD;EACvD,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,uDAAuD;EACvD,qCAAqC;AACvC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,iDAAiD;EACjD,mCAAmC;EACnC,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE;IACE,OAAO;EACT;AACF","sourcesContent":["/* Site diary / Bautagebuch (/user/site-diary, project tab) */\n\n.site-diary-page .sdi-full {\n  width: 100%;\n}\n\n.site-diary-page .sdi-small {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.site-diary-page .sdi-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.site-diary-page .sdi-pre,\n.site-diary-page .sdi-text {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.site-diary-page .sdi-hash {\n  font-family: \"Courier New\", monospace;\n  font-size: 11px;\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.site-diary-page .sdi-card {\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.site-diary-page .sdi-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--ds-text-muted);\n  margin-block: var(--ds-space-2, 8px) 4px;\n}\n\n.site-diary-page .sdi-day-tag {\n  cursor: pointer;\n  margin-block: 2px;\n}\n\n/* ---- Overview ---- */\n.site-diary-page .sdi-project-select {\n  width: 100%;\n  min-width: 0;\n  max-width: 420px;\n}\n\n.site-diary-page .sdi-missing {\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.site-diary-page .sdi-empty {\n  margin-block: var(--ds-space-6, 32px);\n}\n\n.site-diary-page .sdi-project-actions {\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.site-diary-page .sdi-missing-line {\n  margin-bottom: var(--ds-space-2, 8px);\n}\n\n.site-diary-page .sdi-entry-item {\n  cursor: pointer;\n  padding-inline: var(--ds-space-2, 8px);\n  border-radius: var(--ds-radius-sm, 6px);\n}\n\n.site-diary-page .sdi-entry-item:hover {\n  background: var(--ds-surface-muted);\n}\n\n/* ---- Calendar ---- */\n.site-diary-page .sdi-calendar {\n  border: 1px solid var(--ds-border, rgba(0, 0, 0, 0.08));\n  border-radius: var(--ds-radius-md, 10px);\n  padding: var(--ds-space-2, 8px);\n}\n\n.site-diary-page .sdi-cal-cell {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n}\n\n.site-diary-page .sdi-cal-dot,\n.site-diary-page .sdi-legend-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--ds-text-muted);\n}\n\n.site-diary-page .sdi-cal-cell--filled .sdi-cal-dot,\n.site-diary-page .sdi-legend-dot--filled {\n  background: var(--ds-brand, #157f9f);\n}\n\n.site-diary-page .sdi-cal-cell--locked .sdi-cal-dot,\n.site-diary-page .sdi-legend-dot--locked {\n  background: var(--ds-success);\n}\n\n.site-diary-page .sdi-cal-cell--missing .sdi-cal-dot,\n.site-diary-page .sdi-legend-dot--missing {\n  background: var(--ds-danger);\n}\n\n.site-diary-page .sdi-legend {\n  margin-top: var(--ds-space-2, 8px);\n  font-size: 12px;\n}\n\n/* ---- Day editor ---- */\n.sdi-editor {\n  max-width: 880px;\n  margin-inline: auto;\n  padding-bottom: 88px;\n}\n\n.sdi-editor .sdi-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2, 8px);\n  margin-bottom: var(--ds-space-2, 8px);\n}\n\n.sdi-editor .sdi-header-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.sdi-editor .sdi-header-title h4 {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.sdi-editor .sdi-daynav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2, 8px);\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.sdi-editor .sdi-daynav-date {\n  text-align: center;\n  flex: 1;\n}\n\n.sdi-editor .sdi-lock {\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.sdi-editor .sdi-row {\n  padding-block: var(--ds-space-2, 8px);\n  border-bottom: 1px solid var(--ds-border, rgba(0, 0, 0, 0.06));\n}\n\n.sdi-editor .sdi-row-actions {\n  text-align: end;\n}\n\n.sdi-editor .sdi-source {\n  margin-inline-start: var(--ds-space-2, 8px);\n}\n\n.sdi-editor .sdi-add {\n  margin-top: var(--ds-space-2, 8px);\n}\n\n.sdi-editor .sdi-section + .sdi-section {\n  margin-top: var(--ds-space-2, 8px);\n}\n\n.sdi-editor .sdi-card--others {\n  background: var(--ds-surface-muted);\n}\n\n.sdi-editor .sdi-dictation .sdi-mic {\n  margin-top: var(--ds-space-2, 8px);\n  min-height: 40px;\n}\n\n.sdi-editor .sdi-mic--active {\n  animation: sdi-pulse 1.4s ease-in-out infinite;\n}\n\n.sdi-editor .sdi-interim {\n  margin: var(--ds-space-2, 8px) 0 0;\n  font-style: italic;\n}\n\n.sdi-editor .sdi-rec-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--ds-danger);\n}\n\n@keyframes sdi-pulse {\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.sdi-editor .sdi-obstruction {\n  border: 1px solid var(--ds-warning);\n  border-radius: var(--ds-radius-sm, 6px);\n  padding: var(--ds-space-2, 8px) var(--ds-space-3, 12px);\n  margin-bottom: var(--ds-space-2, 8px);\n}\n\n.sdi-editor .sdi-obstruction-foot,\n.sdi-editor .sdi-notice-actions {\n  margin-top: var(--ds-space-2, 8px);\n}\n\n.site-diary-page .sdi-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: var(--ds-space-2, 8px);\n}\n\n.site-diary-page .sdi-photo-grid figure {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.site-diary-page .sdi-photo-grid img,\n.site-diary-page .sdi-photo-grid .ant-image,\n.site-diary-page .sdi-photo-grid .ant-image-img {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: var(--ds-radius-sm, 6px);\n}\n\n.sdi-editor .sdi-photo-actions {\n  margin-block: var(--ds-space-2, 8px);\n}\n\n.sdi-editor .sdi-signatures {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--ds-space-3, 12px);\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.sdi-editor .sdi-signature img {\n  max-height: 72px;\n  max-width: 100%;\n  display: block;\n}\n\n.sdi-editor .sdi-savebar {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--ds-space-2, 8px);\n  padding: var(--ds-space-3, 12px);\n  margin-inline: calc(-1 * var(--ds-space-3, 12px));\n  background: var(--ds-surface, #fff);\n  border-top: 1px solid var(--ds-border, rgba(0, 0, 0, 0.08));\n  z-index: 5;\n}\n\n@media (max-width: 767px) {\n  .sdi-editor .sdi-savebar .ant-btn-primary {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
